import React from 'react';

import { GridFilterItem, GridFilterOperator } from '@mui/x-data-grid';

import CustomUserDropdownField from 'components/SharedFormComponents/CustomUserDropdownField';

import api from 'utils/api';

import { createFilterRegex } from 'utils/regex';
import { PickerProps } from '../types';
import EmptyNotEmpty from '../EmptyNotEmpty';
import { notifyCacheUpdate } from '../cacheEvents';

const UserDropdown: React.FunctionComponent<PickerProps> = ({ applyValue, item, ...props }) => (
  <CustomUserDropdownField
    description="User"
    {...props}
    onChange={(newValue) => applyValue({ ...item, value: newValue ? newValue.uuid : null })}
    value={(item.value as string) || null}
  />
);

const cache = new Map<string, string | undefined>();

const BasicUserOperators = (): GridFilterOperator[] =>
  [
    {
      label: 'is',
      value: 'is',
      getApplyFilterFn: (filterItem: GridFilterItem) => {
        if (!filterItem.value) {
          return null;
        }
        const filterRegex = createFilterRegex(filterItem.value);
        return ({ value }: { value: string }): boolean => (value != null ? filterRegex.test(value.toString()) : false);
      },
      InputComponent: UserDropdown,
      InputComponentProps: { value: null },
      getValueAsString(value: string) {
        if (!cache.has(value)) {
          cache.set(value, undefined);
          api.user
            .loadUserDetails(value)()
            .then(({ data }) => {
              cache.set(value, data.name);
              notifyCacheUpdate();
            })
            .catch(() => {
              cache.delete(value);
            });
        }

        return cache.get(value) || 'loading...';
      },
    },
  ] as unknown as GridFilterOperator[];

export const ExtendedUserOperators = (): GridFilterOperator[] =>
  [...BasicUserOperators(), ...EmptyNotEmpty()] as unknown as GridFilterOperator[];

export default BasicUserOperators;
